import styles from './AssistantFAB.module.css';

interface AssistantFABProps {
  onClick: () => void;
  isOpen: boolean;
  hasPayNow: boolean;
}

export function AssistantFAB({ onClick, isOpen, hasPayNow }: AssistantFABProps) {
  return (
    <button
      type="button"
      className={styles.fab}
      onClick={onClick}
      aria-label={isOpen ? 'Close assistant' : 'Open assistant'}
      data-testid="assistant-fab"
      style={{
        bottom: hasPayNow
          ? 'calc(16px + var(--pay-now-height))'
          : 'calc(16px + env(safe-area-inset-bottom))',
      }}
    >
      {isOpen ? (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      ) : (
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M12 2a7 7 0 0 1 7 7v2.5a1.5 1.5 0 0 1 0 3V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-4.5a1.5 1.5 0 0 1 0-3V9a7 7 0 0 1 7-7z" />
          <path d="M9 13h6" />
          <path d="M9 17h6" />
          <circle cx="9" cy="9" r="1" fill="currentColor" stroke="none" />
          <circle cx="15" cy="9" r="1" fill="currentColor" stroke="none" />
        </svg>
      )}
    </button>
  );
}
